module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<form id=\"user_edit_password\"> <div class=\"card\"> <div class=\"card-body\"> <div class=\"form-group\"> <label>Current Password <small class=\"text-muted\">(Required to change password)</small></label> <input type=\"password\" class=\"form-control\" id=\"user_current_password\"> </div> <div class=\"form-group\"> <label>Password <small class=\"text-muted\">(Case-sensitive. Minimum of 8 characters)</small></label> <input type=\"password\" class=\"form-control\" id=\"user_password\"> </div> <div class=\"form-group\"> <label>Password Confirmation</label> <input type=\"password\" class=\"form-control\" id=\"user_password_confirmation\"> </div> <p class=\"small text-muted\">Note: When you successfully change your password, all website logins on other browsers and devices will be required to log in with the new password.</p> <button type=\"submit\" class=\"btn btn-secondary\">Update Password</button> </div> </div> </form> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/user_edit/edit_password/template.ejs
// module id = 1851
// module chunks = 1